import { graphql, Link, StaticQuery } from "gatsby"
import React, { Component } from "react"

import ProjectsTile from "./widgets/ProjectsTile"

import * as projectsStyles from "../styles/projects.module.css"

const query = graphql`
  query ProjectsQuery {
    dataJson(title: { eq: "Projects" }) {
      projects {
        name
        desc
        url
        img {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        techs {
          name
          url
          img {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        urls {
          name
          url
          img {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`

class Projects extends Component {
  render() {
    return (
      <StaticQuery
        query={query}
        render={data => (
          <React.Fragment>
            <div
              className="container"
            // data-sal="fade"
            // data-sal-delay="50"
            // data-sal-easing="ease"
            >
              <div className={projectsStyles.divider}></div>
              <div className={projectsStyles.title}>
                PROJECTS
                <div className={projectsStyles.desc}>
                  &lt;PERSONAL PROJECTS/&gt;
                </div>
              </div>
              <div className={`row ${projectsStyles.row}`}>
                {data.dataJson.projects.slice(0, 4).map(project => (
                  <ProjectsTile
                    key={project.name}
                    name={project.name}
                    desc={project.desc}
                    url={project.url}
                    fluid={project.img.childImageSharp.fluid}
                    techStack={project.techs}
                    urls={project.urls}
                  />
                ))}
              </div>
            </div>
            <div className={`row ${projectsStyles.moreProjectsDiv}`}>
              <Link className={`${projectsStyles.moreProjects}`} to="/projects">
                {" "}
                &lt; More Projects /&gt;
              </Link>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
}
export default Projects
